import { Component } from '@angular/core';
declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'app-planos',
  templateUrl: './planos.component.html',
  styleUrls: ['./planos.component.scss']
})
export class PlanosComponent {


  public  TiposAccion = [
    { value: "1", label: "CREACIÓN", job: "Developer" },
    { value: "2", label: "MODIFICACIÓN", job: "Developer" },
    { value: "3", label: "ELIMINACIÓN", job: "Developer" },
  ];
  public tipoaccion: string; // Aquí se almacena el valor seleccionado del <ng-select>
  
  public  Tipocontrato = [
    { value: "1", label: "POR VINCULACIÓN Y ADMINISTRACIÓN DE FLOTA (VEH PROPIO)", job: "Developer" },
    { value: "2", label: "PRESTAMO DE SERVICIO", job: "Developer" },

  ];
  public tipocontrato: string; // Aquí se almacena el valor seleccionado del <ng-select>

  public  Tipovehiculo = [
    { value: "1", label: "AUTOMOVIL", job: "Developer" },
    { value: "2", label: "VANS", job: "Developer" },
    { value: "2", label: "CAMION", job: "Developer" },
    { value: "2", label: "BUSETA", job: "Developer" },

  ];
  public tipovehiculo: string; // Aquí se almacena el valor seleccionado del <ng-select>


  public  Tipodocumento = [
    { value: "1", label: "CÉDULA CIUDADANIA", job: "Developer" },
    { value: "2", label: "NIT", job: "Developer" },
    { value: "2", label: "PASAPORTE", job: "Developer" },
    { value: "2", label: "CEDULA DE EXTRANJERÍA", job: "Developer" },

  ];
  public tipodocumento: string; // Aquí se almacena el valor seleccionado del <ng-select>
  
  public counter: number[] = [18, 40, 55, 40, 40, 40, 20, 40, 50.00, 40, 40, 50, 50, 40, 60, 40];
  public contents = ["Action", "Another Action", "Something Else Here"];
  
  public increment(i) {
    if (i === 0 || i === 1 || i === 2 || i === 3 || i === 5 || i === 6 || i === 8 || i === 9 || i === 10 || i === 11 || i === 12 || i === 13 || i === 14) {
      this.counter[i] += 1;
    }
    else if (i === 4) {
      if (this.counter[i] < 80) {
        this.counter[i] += 1;
      }
    }
    else if (i === 7) {
      this.counter[i] += 0.25;
    }
  }
  
  public decrement(i) {
    if (i === 0 || i === 1 || i === 2 || i === 3 || i === 5 || i === 6 || i === 8 || i === 9 || i === 10 || i === 11 || i === 12 || i === 13 || i === 14) {
      if (this.counter[i] > 1) {
        this.counter[i] -= 1;
      }
    }
    else if (i === 4) {
      if (this.counter[i] > 40) {
        this.counter[i] -= 1;
      }
    }
    else if (i === 7) {
      if (this.counter[i] > 1) {
        this.counter[i] -= 0.25;
      }
    }
  }
  
  files: File[] = [];
  files1: File[] = [];
  
  onSelect(event) {
    this.files.push(...event.addedFiles);
    if(this.files.length > 1){
      this.replaceFile();
    }
  }
  
  replaceFile() {
    this.files.splice(0,1);
  }
  
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  
  onSelect1(event) {
    this.files1.push(...event.addedFiles);
  }
  
  withConfirmation() {
    Swal.fire({
    title: 'Deseas guardar',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        )
      }
    })
  }
  
  constructor() { }
  
  ngOnInit() {
  }
  
  }
  
  